import { RouteRecordRaw } from "vue-router";

const trainRoutes: RouteRecordRaw[] = [
  {
    path: "/train",
    name: "train",
    meta: {
      label: "模型定制",
      auth: false,
      layout: "homeWorkbench",
      useTopbar: true
    },
    component: () => import("@/views/train/index.vue")
  },
  {
    path: "/train/new/:id?",
    name: "newTrain",
    meta: {
      label: "新建训练",
      auth: true,
      layout: "home",
      useTopbar: true,
      layoutHidden: true
    },
    component: () => import("@/views/train/children/newTrain/index.vue")
  },
  {
    path: "/train/style-render/new/:id?",
    name: "styleRenderTrainNew",
    meta: {
      label: "风格渲染模型训练",
      auth: true,
      layout: "home",
      useTopbar: true,
      layoutHidden: true
    },
    component: () => import("@/views/train/children/styleRenderTrain/index.vue")
  },
  {
    path: "/train/templateDetail",
    name: "templateDetail",
    meta: {
      label: "模板详情预览",
      auth: false,
      layout: "home",
      useTopbar: true,
      layoutHidden: true
    },
    component: () => import("@/views/train/children/templateDetail/index.vue")
  },
  {
    path: "/train/modelCombination/:id?",
    name: "modelCombination",
    meta: {
      label: "模型组合",
      auth: true,
      useTopbar: true,
      layout: "home",
      layoutHidden: true
    },
    component: () => import("@/views/train/children/modelCombination/index.vue")
  },
  {
    path: "/train/style-render/debug/:id",
    name: "styleRenderDebug",
    meta: {
      label: "提示词调试",
      auth: true,
      layout: 'simple',
      useTopbar: true,
      layoutHidden: true
    },
    component: () => import("@/views/train/children/promptDebug/index.vue")
  }
];

export default trainRoutes;
